import { BRAND_LOGGED_IN_START_PAGE } from "@chef/constants";

import { Logo } from "../Logo";
import { DrawerButton } from "./Drawer/DrawerButton";

import { WeeksNavigation } from "./WeeksNavigation";

export const MyDeliveryVariant = () => {
  return (
    <div className="flex-col gap-2">
      <div
        id="my-delivery-header"
        className="relative flex items-center justify-between w-full h-15"
      >
        <div className="flex w-24 md:w-48">
          <Logo responsive href={BRAND_LOGGED_IN_START_PAGE} />
        </div>

        <WeeksNavigation variant="my-delivery" />

        <div className="flex items-center justify-end w-24 gap-4 md:w-48">
          <DrawerButton />
        </div>
      </div>
    </div>
  );
};
